'use strict';

/**
 *
 * @name: localPlaylist
 *
 */

function LocalPlaylistFactory(
  $rootScope,
  apiBookmarkService,
  $location,
  transObject,
  $q,
  $localStorage,
  apiPostService
) {

  'ngInject';

  var currentItem = 0;

  $rootScope.$watch('threeTimesAVirgin', function (newVal) {
    if ($rootScope.isLocalStorageSupported && (newVal || newVal === 0)) {
      if ($localStorage.Nowness && $localStorage.Nowness.playlist) {
        $localStorage.Nowness.playlist.threeTimesAVirgin = $rootScope.threeTimesAVirgin;
      }
    }
  });

  function addBookmark(item) {

    var deferred = $q.defer();
    var bookmarkedPost = {
      PostId: item.id,
      UserId: $rootScope.profile.id,
      createdAt: moment().toISOString(),
      updatedAt: moment().toISOString(),
      post: angular.copy(item)
    };

    if (bookmarkedPost.post.series && bookmarkedPost.post.series.posts && bookmarkedPost.post.series.posts.length) {

      bookmarkedPost.post.series.posts = [];
    }

    // var isItOn = $rootScope.showPersistentVideo;

    if ($rootScope.profile) {

      if (item.translations[$rootScope.lang]) {

        apiBookmarkService
          .createBookmark(item.id)
          .then(function (res) {

            $rootScope.playlist.items.push(bookmarkedPost);
            item.isBookmarked = true;
            $rootScope.threeTimesAVirgin++;

            // https://app.asana.com/0/709099057354040/746389371856671/f
            // if (!isItOn && $rootScope.threeTimesAVirgin <= 3) {
            // $rootScope.showPersistentVideo = true;
            // $timeout(function () {
            // $rootScope.showPersistentVideo = false;
            // }, 1533);
            // }

            setTimeout(function () {

              $rootScope.$apply(function () {

                $rootScope.swappySwap = true;
              });
            });

            setTimeout(function () {

              $rootScope.$apply(function () {

                $rootScope.swappySwap = false;
              });
            }, 1533);

            deferred.resolve(res);
          }, function (err) {

            deferred.reject(err);
          });
      } else {

        deferred.reject('not available in your language');
      }
    } else {

      if (item.translations[$rootScope.lang]) {

        $rootScope.playlist.items.push(bookmarkedPost);
        item.isBookmarked = true;
        $rootScope.threeTimesAVirgin++;

        // https://app.asana.com/0/709099057354040/746389371856671/f
        // if (!isItOn && $rootScope.threeTimesAVirgin <= 3) {
        // $rootScope.showPersistentVideo = true;
        // $timeout(function () {
        // $rootScope.showPersistentVideo = false;
        // }, 1533);
        // }

        setTimeout(function () {

          $rootScope.$apply(function () {

            $rootScope.swappySwap = true;
          });
        });

        setTimeout(function () {

          $rootScope.$apply(function () {

            $rootScope.swappySwap = false;
          });
        }, 1500);

        deferred.resolve('added');
      } else {

        deferred.reject('not available in your language');
      }
    }

    return deferred.promise;
  }

  function changeSource(source, internalUse) {

    var deferred = $q.defer();

    if ($rootScope.playlist.settings && $rootScope.playlist.settings.source) {

      $rootScope.playlist.settings.source = source;
    } else {

      $rootScope.playlist.settings = {
        source: source,
        active: false
      };
    }

    currentItem = 0;

    if (internalUse) {

      deferred.resolve(true);

    } else if (source === 'items') {

      deferred.resolve($rootScope.playlist.items);
    } else {

      deferred.resolve(getSource(source));
    }
    return deferred.promise;
  }

  function getCurrentPlaylist() {

    var deferred = $q.defer();

    if (typeof $rootScope.profile === 'object') {

      deferred.resolve(_getPlaylist());
    } else if ($rootScope.profile === false) {

      if ($rootScope.isLocalStorageSupported && $localStorage.Nowness.playlist) {

        $rootScope.playlist = {
          items: $localStorage.Nowness.playlist.items
        };
      } else {

        $rootScope.playlist = {
          items: []
        };

        if ($rootScope.isLocalStorageSupported) {

          $localStorage.Nowness.playlist = $rootScope.playlist;
        }
      }

      changeSource('items', true);
      deferred.resolve('Ok, playlist set');
    }

    return deferred.promise;
  }

  function getSource(source) {

    var deferred = $q.defer();
    var order = '';

    if (source === 'selected') {

      order = 'recommended desc';
    } else if (source === 'mostViewed') {

      order = 'viewsCount desc';
    } else if (source === 'recent') {

      order = 'publishDate desc';
    }

    if (!$rootScope.playlist[source]) {

      apiPostService
        .getPost(false, order, 1, 16)
        .then(function (res) {

          res.data.items.forEach(function (item, index) {

            transObject.translate(item);
            transObject.getDuration(item);
            transObject.setBookmark(item);
            transObject.trueSlug(item);
            res.data.items[index] = {
              PostId: item.id,
              post: item
            };
          });

          $rootScope.playlist[source] = res.data.items;

          deferred.resolve(res.data.items);
        }, function (err) {

          deferred.reject(err);
        });
    } else {

      deferred.resolve($rootScope.playlist[source]);
    }

    return deferred.promise;
  }

  function nextStory(dir) {

    resetCounter();
    var source = $rootScope.playlist.settings.source;
    $location.url($location.path());

    if (currentItem !== -1 &&
      currentItem !== $rootScope.playlist[source].length &&
      $rootScope.playlist[source][currentItem] &&
      $location.url() !== '/story/' + $rootScope.playlist[source][currentItem].post.translations[$rootScope.lang].slug) {

      $rootScope.playlist.settings.active = false;
      currentItem = 0;
    }

    // play only if playlist active
    if ($rootScope.playlist.settings.active) {

      if (dir === 'prev' && $rootScope.playlist[source][currentItem - 1]) {
        currentItem--;

        if ('/story/' + $rootScope.playlist[source][currentItem].post.translations[$rootScope.lang].slug !== $location.url()) {

          $location.path('/story/' + $rootScope.playlist[source][currentItem].post.translations[$rootScope.lang].slug);
        } else {

          nextStory('prev');
        }
      } else if (!dir && $rootScope.playlist[source][currentItem + 1]) {

        currentItem++;

        if ('/story/' + $rootScope.playlist[source][currentItem].post.translations[$rootScope.lang].slug !== $location.url()) {

          $location.path('/story/' + $rootScope.playlist[source][currentItem].post.translations[$rootScope.lang].slug);
          removeBookmark($rootScope.playlist.items[currentItem - 1].post);
        } else {

          nextStory();
        }
      } else if (!dir && !$rootScope.playlist[source][currentItem + 1]) {

        removeBookmark($rootScope.playlist.items[currentItem].post);
        $location.path('/');
      }
    } else {

      return;
    }
  }

  function removeBookmark(item) {

    var deferred = $q.defer();

    if ($rootScope.profile) {

      var itemId;

      if (item) {
        itemId = item.id;
      }

      apiBookmarkService
        .deleteBookmark(itemId)
        .then(function (res) {

          if (item) {

            $rootScope.playlist.items.forEach(function (localItem, index) {

              if (localItem.PostId === item.id) {

                item.isBookmarked = false;
                $rootScope.playlist.items.splice(index, 1);
                if ($rootScope.playlist && $rootScope.playlist.settings.active && currentItem >= index) {

                  currentItem--;
                }
              }
            });
          } else {

            $rootScope.playlist.items = [];
          }

          deferred.resolve(res);
        }, function (err) {

          deferred.reject(err);
        });
    } else {

      if (item) {

        $rootScope.playlist.items.forEach(function (localItem, index) {

          if (localItem.PostId === item.id) {

            item.isBookmarked = false;
            $rootScope.playlist.items.splice(index, 1);

            if ($rootScope.playlist && $rootScope.playlist.settings.active && currentItem >= index) {

              currentItem--;
            }

            deferred.resolve('removed');
          }
        });
      } else {

        $rootScope.playlist.items = [];
      }
    }

    return deferred.promise;
  }

  function resetCounter() {

    $rootScope.videoCounter = '';
  }

  function startAndSetCurrentItem(index, item) {

    $rootScope.playlist.settings.active = true;
    currentItem = index;

    if (item) {

      $location.path('/story/' + item.post.translations[$rootScope.lang].slug);
    }
  }

  function updateCounter(count) {

    var hours = Math.floor(count / 3600);
    var remainingSecondsInHour = count % 3600;
    var minutes = Math.floor(remainingSecondsInHour / 60);
    var remainingSecondsInMinute = remainingSecondsInHour % 60;

    if (minutes < 10) {

      minutes = '0' + minutes;
    }

    if (remainingSecondsInMinute < 10) {

      remainingSecondsInMinute = '0' + remainingSecondsInMinute;
    }

    var newerCount = (hours > 0 ? hours + ':' : '') + (minutes > 0 ? minutes + ':' : '') + remainingSecondsInMinute;
    $rootScope.videoCounter = newerCount;
  }

  /**
   *
   * @PRIVATE
   *
   */


  function _getPlaylist() {

    var deferred = $q.defer();
    var idList;

    if ((!$rootScope.playlist || !$rootScope.playlist.idList) && $rootScope.isLocalStorageSupported) {

      if ($localStorage.Nowness.playlist && $localStorage.Nowness.playlist.idList && $localStorage.Nowness.playlist.idList.length) {

        idList = $localStorage.Nowness.playlist.idList;
      } else {
        idList = [];

        $rootScope.playlist = {
          idList: []
        };

      }
    } else if ((!$rootScope.playlist || !$rootScope.playlist.idList) && $rootScope.isSessionStorageSupported) {

    } else if ($rootScope.playlist && $rootScope.playlist.idList && $rootScope.playlist.idList.length) {

      idList = $rootScope.playlist.idList;
    }

    var getFromServer = function () {

      apiPostService
        .getPost(false, false, 1, 888, null, null, undefined, $rootScope.profile.id)
        .then(function (res) {

          res.data.items.forEach(function (item, index) {

            res.data.items[index] = {
              post: item,
              PostId: item.id,
              UserId: $rootScope.profile.id
            };
          });

          var bookmarks = res.data;

          bookmarks.items.forEach(function (item) {

            transObject.translate(item.post);
            transObject.getDuration(item.post);
            transObject.trueSlug(item.post);
          });

          $rootScope.playlist = bookmarks;

          if ($rootScope.isLocalStorageSupported) {

            $localStorage.Nowness.playlist = $rootScope.playlist;
          }

          changeSource('items', true);

          function createIdList() {

            var tempArr = [];

            $rootScope.playlist.items.forEach(function (item) {

              var postId = parseInt(item.post.id, 10);
              tempArr.push(postId);
            });
          }

          createIdList();

          deferred.resolve(bookmarks);
        }, function (err) {

          deferred.reject(err);
        });
    };

    if (idList) {
      //bysxz bookmark
      apiBookmarkService
        .deleteBookmark()
        .then(function () {

          apiBookmarkService
            .importBookmarks(idList)
            .then(function () {

              getFromServer();
            });
        });
    } else {

      getFromServer();
    }

    return deferred.promise;
  }

  return {
    addBookmark: addBookmark,
    changeSource: changeSource,
    getCurrentPlaylist: getCurrentPlaylist,
    nextStory: nextStory,
    removeBookmark: removeBookmark,
    resetCounter: resetCounter,
    returnCurrentItem: function () {
      return currentItem;
    },
    startAndSetCurrentItem: startAndSetCurrentItem,
    updateCounter: updateCounter,

  };
}

export default LocalPlaylistFactory;



// WEBPACK FOOTER //
// ./app/components/nn-bookmark/nn-local-playlist.factory.js